(function (angular, app) {
    'use strict';

    app.controller('OutOfStockCtrl', [
        '$rootScope', '$scope', 'Dialog', 'Api', 'User', 'Util', '$timeout', 'Config', 'DataLayer', 'lines', 'Cart', '$q',
        function ($rootScope, $scope, Dialog, api, user, util, $timeout, Config, DataLayer, lines, Cart, $q) {
            var outOfStockCtrl = this;
            outOfStockCtrl.lines = lines;
            outOfStockCtrl.isSentData = false;
            outOfStockCtrl.productsCount = 0;
            outOfStockCtrl.couponsCount = 0;
            var outOfStockProductIds = [];
            var invalidCoupons = [];
            angular.forEach(outOfStockCtrl.lines, function(line) {
                if (line.isProductOutOfStock) {
                    ++outOfStockCtrl.productsCount;
                    outOfStockProductIds.push(line.product.id);
                }
                if (line.isCouponActive === false) {
                    ++outOfStockCtrl.couponsCount;
                    invalidCoupons.push(line.product.localName);
                }
            });
            $rootScope.$emit($rootScope.SP_SERVICES.MIXPANEL_EVENTS_LISTENERS.MIXPANEL_OUT_OF_STOCK_POP_UP_SHOWN_AT_CHECKOUT, {
                outOfStockProductIds: outOfStockProductIds,
                invalidCoupons: invalidCoupons
            });
            outOfStockCtrl.removeLines = function () {
                outOfStockCtrl.isSentData = true;
                var promises = [];
                angular.forEach(outOfStockCtrl.lines, function(line) {
                    if (line.isProductOutOfStock || line.isCouponActive === false) {
                        promises.push(Cart.removeLine(line, true, true));
                    }
                });

                $q.all(promises).then(function() {
                    Dialog.hide({isConfirmed: true});
                });
            };
            outOfStockCtrl.backToCart = function () {
                Dialog.hide({isConfirmed: false});
            };
        }]);
})(angular, app);